export default "__VITE_ASSET__BijD_F5J__"